import { render, staticRenderFns } from "./look-activity.vue?vue&type=template&id=4d047999&scoped=true&"
import script from "./look-activity.vue?vue&type=script&lang=js&"
export * from "./look-activity.vue?vue&type=script&lang=js&"
import style0 from "./look-activity.vue?vue&type=style&index=0&id=4d047999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d047999",
  null
  
)

export default component.exports